var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.709,
    height: 86.666,
    viewBox: "0 0 86.709 86.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    "data-name": "Path 3919",
    d: "M-66.669,218.993c0,1.928-.01,3.73,0,5.531a1.707,1.707,0,0,1-.9,1.792c-.761.367-1.312-.042-1.859-.476-2.659-2.109-5.3-4.236-7.989-6.309a2.667,2.667,0,0,0-1.5-.514c-4.2-.04-8.41-.021-12.614-.024-4.794,0-7.982-3.17-7.987-7.937q-.008-7.756,0-15.511a7.518,7.518,0,0,1,7.929-7.9q13.736-.005,27.472,0a7.511,7.511,0,0,1,7.91,7.919q.009,7.755,0,15.511a7.527,7.527,0,0,1-7.914,7.918C-64.922,218.994-65.728,218.993-66.669,218.993Zm-2.939,2.968c0-1.541-.009-2.816,0-4.091.011-1.259.564-1.8,1.836-1.814,1.339-.01,2.677,0,4.016,0a4.472,4.472,0,0,0,4.61-4.586q.015-8.125,0-16.25a4.47,4.47,0,0,0-4.655-4.633q-14.056-.008-28.111,0a4.476,4.476,0,0,0-4.665,4.716q-.007,8.032,0,16.063a4.489,4.489,0,0,0,4.694,4.69c3.985.006,7.973.1,11.953-.042a6.706,6.706,0,0,1,5.139,1.815C-73.218,219.262-71.463,220.5-69.608,221.962Z",
    transform: "translate(142.908 -187.641)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3920",
    "data-name": "Path 3920",
    d: "M-321.164,474.985c-1.5-.081-2.877-.046-4.219-.249a7.249,7.249,0,0,1-6.224-7.1q-.1-8.408,0-16.818a7.325,7.325,0,0,1,7.23-7.24q14.389-.1,28.779,0a7.337,7.337,0,0,1,7.258,7.311q.1,8.314,0,16.632a7.418,7.418,0,0,1-7.5,7.372c-4.36.037-8.721-.008-13.081.032a2.673,2.673,0,0,0-1.5.517c-2.663,2.053-5.285,4.158-7.919,6.248-.569.452-1.126.918-1.93.533s-.907-1.1-.9-1.884C-321.152,478.57-321.164,476.8-321.164,474.985Zm2.939,2.839c.4-.289.649-.456.884-.641,1.854-1.468,3.72-2.922,5.55-4.419a3.368,3.368,0,0,1,2.294-.816q6.911.053,13.823.01a4.445,4.445,0,0,0,4.41-4.4q.03-8.312,0-16.625a4.433,4.433,0,0,0-4.381-4.429q-14.336-.024-28.673,0a4.423,4.423,0,0,0-4.364,4.347q-.037,8.359,0,16.718a4.464,4.464,0,0,0,4.422,4.393c1.4.018,2.8,0,4.2.006,1.269.01,1.821.557,1.833,1.818S-318.225,476.335-318.225,477.823Z",
    transform: "translate(331.66 -395.701)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M-260.134,236.733a22.345,22.345,0,0,0-6.86,1.925c-9.146,4.21-14.621,11.294-16.362,21.216-.235,1.339-.178,2.728-.3,4.089a1.4,1.4,0,0,1-1.529,1.414,1.415,1.415,0,0,1-1.367-1.564c0-.124,0-.249,0-.373a30.523,30.523,0,0,1,24.017-29.253c.9-.188,1.811-.333,2.91-.533-.611-.619-1.121-1.138-1.633-1.655-.285-.288-.584-.562-.856-.86a1.461,1.461,0,0,1-.078-2.156,1.46,1.46,0,0,1,2.156.129c.7.663,1.363,1.367,2.054,2.04.913.89,1.83,1.777,2.759,2.65a1.564,1.564,0,0,1,.068,2.445q-2.541,2.543-5.1,5.064c-.784.769-1.579.827-2.223.21-.665-.638-.61-1.485.2-2.287.764-.76,1.566-1.482,2.351-2.221Z",
    transform: "translate(294.987 -220.916)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M-77.028,443.562c.8.78,1.559,1.505,2.3,2.252.818.828.9,1.637.254,2.294-.606.62-1.51.531-2.3-.234q-2.379-2.306-4.753-4.618a1.555,1.555,0,0,1-.018-2.383q2.642-2.575,5.309-5.124a1.487,1.487,0,0,1,2.228-.1,1.442,1.442,0,0,1-.17,2.148c-.816.842-1.649,1.668-2.608,2.635a25.754,25.754,0,0,0,9.615-3.227,27.356,27.356,0,0,0,13.919-20.558c.159-1.073.171-2.17.225-3.258.051-1.041.608-1.706,1.463-1.7a1.539,1.539,0,0,1,1.445,1.727,30.025,30.025,0,0,1-7.328,19.5,29.8,29.8,0,0,1-18.679,10.345,4.956,4.956,0,0,0-.547.12A2.682,2.682,0,0,0-77.028,443.562Z",
    transform: "translate(128.742 -369.812)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3923",
    "data-name": "Path 3923",
    d: "M-.472,257.52a2.951,2.951,0,0,1,2.92,2.9,2.942,2.942,0,0,1-3,2.918,2.947,2.947,0,0,1-2.92-2.9A2.952,2.952,0,0,1-.472,257.52Z",
    transform: "translate(64.813 -244.459)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3924",
    "data-name": "Path 3924",
    d: "M-48.5,263.349a2.945,2.945,0,0,1-2.958-2.862,2.942,2.942,0,0,1,2.954-2.959,2.946,2.946,0,0,1,2.959,2.862A2.944,2.944,0,0,1-48.5,263.349Z",
    transform: "translate(103.834 -244.465)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3925",
    "data-name": "Path 3925",
    d: "M55.455,263.345a2.911,2.911,0,1,1,2.994-2.922A2.949,2.949,0,0,1,55.455,263.345Z",
    transform: "translate(19.28 -244.461)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3926",
    "data-name": "Path 3926",
    d: "M-176.552,519.342a2.948,2.948,0,0,1-2.918-2.9,2.952,2.952,0,0,1,3-2.918,2.951,2.951,0,0,1,2.918,2.906A2.942,2.942,0,0,1-176.552,519.342Z",
    transform: "translate(207.917 -452.608)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    "data-name": "Path 3927",
    d: "M-224.556,519.348a2.951,2.951,0,0,1-2.913-2.909,2.948,2.948,0,0,1,3-2.912,2.951,2.951,0,0,1,2.913,2.909A2.945,2.945,0,0,1-224.556,519.348Z",
    transform: "translate(246.944 -452.614)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3928",
    "data-name": "Path 3928",
    d: "M-280.493,519.345a2.949,2.949,0,0,1-2.974-2.941,2.949,2.949,0,0,1,2.941-2.881,2.947,2.947,0,0,1,2.973,2.941A2.939,2.939,0,0,1-280.493,519.345Z",
    transform: "translate(292.476 -452.611)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessage);
export default __webpack_public_path__ + "static/media/NewMessage.900fe7afdce50bd49d11d5729199e588.svg";
export { ForwardRef as ReactComponent };